import { Col, Row, Table } from 'antd';
import { useMemo } from 'react';


export default (props) => {

    const {
        items = [],
        onPagniationChange,
        onSortChange,
        onDelete,
        pageNo,
        total,
        defaultPageSize,
        showEditModal,
        sortBy,
        sortOrder,
        hasEditAccess = false,
        hasDeleteAccess = false,
    } = props;

    // let navigate = useNavigate();

    const columns = useMemo(() => {

        let titleCol = { defaultSortOrder: undefined }

        const defaultSortOrder = sortOrder === 'ascend' ? 'ascend' : 'descend';

        if (sortBy === 'title') {
            titleCol = { defaultSortOrder }
        }

        return [
            {
                title: 'Title',
                dataIndex: 'title',
                key: 'title',
                sorter: true,
                ...titleCol,
            },
            {
                title: '',
                dataIndex: 'id',
                key: 'id',
                render: (text, record) => {

                    return (
                        <a
                            data-testid='edit-material'
                            onClick={() => {
                                showEditModal && showEditModal({
                                    id: record.id,
                                    title: record.title,

                                });
                            }}>
                            Edit
                        </a>
                    )
                },
            },
            {
                title: '',
                dataIndex: 'id',
                key: 'id',
                render: (text, record) => {

                    return (
                        <a
                            data-testid='delete-material'
                            onClick={() => {
                                onDelete && onDelete(record.id, record.title)
                            }}>
                            Delete
                        </a>
                    )
                },
            },
        ]
    }, [sortBy, sortOrder, hasDeleteAccess, hasEditAccess, showEditModal]);


    const onChangeTable = (pagination, filters, sorter, extra) => {
        try {

            // console.log('on change', pagination, filters, sorter, extra);

            if (extra.action === 'paginate') {
                onPagniationChange && onPagniationChange(pagination);
            } else if (extra.action === 'sort') {
                onSortChange && onSortChange(sorter)
            }

        } catch (error) {
            console.log('error on table change', error);
        }
    }

    return (
        <div>
            <Row>
                <Col justify='flex-start' span={24} style={{
                    paddingTop: '0px'
                }}>
                    <Table
                        columns={columns}
                        dataSource={items}
                        rowKey={'id'}
                        pagination={{
                            current: pageNo + 1,
                            defaultPageSize,
                            total,
                        }}
                        onChange={onChangeTable}
                    />
                </Col>
            </Row>
        </div>
    );

}